import React, { FC, ReactNode } from 'react';
import {
    useReportWidgetData,
    UseReportWidgetDataProps
} from '@src/components/features/reports-and-logs/executive-summary/useReportWidgetData';
import Loader from '@src/components/shared/loader/loader';

interface ReportWidgetLoaderProps {
  hookProps: UseReportWidgetDataProps;
  children: (data: any, error: string | null) => ReactNode;
}

export const ReportWidgetLoader: FC<ReportWidgetLoaderProps> = ({ hookProps, children }) => {
  const { data, loading, error } = useReportWidgetData(hookProps);

  return <>
    {loading && <Loader type="component" />}
    {!loading && <>{children(data, error)}</>}
  </>;
};



